import { Pipe, PipeTransform } from '@angular/core';

import { Defaults } from 'src/app/config/defaults';

import lodash from 'lodash';

/*
  Pipe that formats a number as a monetary value. Defaults to euro.
*/
@Pipe({
  name: 'monetary',
})
export class MonetaryPipe implements PipeTransform {
  transform(value: string | number | null | undefined): any {
    if (value || value === 0) {
      const amount = lodash
        .toNumber(value)
        .toFixed(2);

      return `${amount} ${Defaults.CurrencySymbol}`;
    }

    return null;
  }
}
